import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, MessageCircle, MapPin, Clock, User, FolderOpen } from 'lucide-react';
export function HeroSection() {
  const scrollToContact = () => {
    document.querySelector('#contacto')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-24 pb-16 lg:pt-48 lg:pb-32 overflow-hidden bg-white" data-id="element-56">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative" data-id="element-57">
        <div className="lg:grid lg:grid-cols-12 lg:gap-16 items-center" data-id="element-58">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5
        }} className="lg:col-span-6 text-center lg:text-left mb-12 lg:mb-0" data-id="element-59">
            <h1 className="text-3xl sm:text-5xl lg:text-6xl font-extrabold text-gray-900 tracking-tight mb-5 leading-tight" data-id="element-60">
              Nunca más pierdas <br className="hidden sm:block" data-id="element-61" />
              <span className="text-blue-600" data-id="element-62">registro de tu obra.</span>
            </h1>
            <p className="text-lg sm:text-xl text-gray-600 mb-6 max-w-2xl mx-auto lg:mx-0" data-id="element-63">
              Centraliza todas las fotos de obra automáticamente desde WhatsApp.
              Sin apps nuevas, sin fricción.
            </p>

            <div className="grid grid-cols-2 gap-2 sm:gap-3 mb-5 max-w-2xl mx-auto lg:mx-0" data-id="element-64">
              <div className="flex items-start sm:items-center text-xs sm:text-sm text-gray-500" data-id="element-65">
                <MapPin className="w-4 h-4 mr-1.5 sm:mr-2 text-blue-500 flex-shrink-0 mt-0.5 sm:mt-0" data-id="element-66" />
                <span data-id="element-67">Ubicadas en plano por piso o sector</span>
              </div>
              <div className="flex items-start sm:items-center text-xs sm:text-sm text-gray-500" data-id="element-68">
                <Clock className="w-4 h-4 mr-1.5 sm:mr-2 text-blue-500 flex-shrink-0 mt-0.5 sm:mt-0" data-id="element-69" />
                <span data-id="element-70">Timestamp verificable</span>
              </div>
              <div className="flex items-start sm:items-center text-xs sm:text-sm text-gray-500" data-id="element-71">
                <User className="w-4 h-4 mr-1.5 sm:mr-2 text-blue-500 flex-shrink-0 mt-0.5 sm:mt-0" data-id="element-72" />
                <span data-id="element-73">Registro de quién envió</span>
              </div>
              <div className="flex items-start sm:items-center text-xs sm:text-sm text-gray-500" data-id="element-74">
                <FolderOpen className="w-4 h-4 mr-1.5 sm:mr-2 text-blue-500 flex-shrink-0 mt-0.5 sm:mt-0" data-id="element-75" />
                <span data-id="element-76">Ordenadas por obra</span>
              </div>
            </div>

            <div className="border-l-2 border-blue-500 pl-3 mb-6 max-w-2xl mx-auto lg:mx-0" data-id="element-77">
              <p className="text-sm sm:text-base font-medium text-gray-800 italic" data-id="element-78">
                "Un historial técnico preciso, no un chat desordenado."
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center lg:justify-start" data-id="element-79">
              <button onClick={scrollToContact} className="inline-flex justify-center items-center px-5 sm:px-6 py-3 sm:py-3.5 border border-transparent text-sm sm:text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 shadow-sm transition-colors" data-id="element-80">
                Probar en mi obra
              </button>
              <button onClick={scrollToContact} className="inline-flex justify-center items-center px-5 sm:px-6 py-3 sm:py-3.5 border border-gray-300 text-sm sm:text-base font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 shadow-sm transition-colors" data-id="element-81">
                Agendar demo
              </button>
            </div>
          </motion.div>

          {/* CSS Mockup Illustration */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="lg:col-span-6 relative" data-id="element-82">
            <div className="relative w-full max-w-lg mx-auto" data-id="element-83">
              {/* Browser Window Mockup */}
              <div className="bg-white rounded-xl shadow-2xl border border-gray-200 overflow-hidden relative z-10 ml-4 sm:ml-16" data-id="element-84">
                {/* Browser Header */}
                <div className="bg-gray-50 border-b border-gray-200 px-3 sm:px-4 py-2 sm:py-3 flex items-center gap-2" data-id="element-85">
                  <div className="flex gap-1.5" data-id="element-86">
                    <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-red-400" data-id="element-87"></div>
                    <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-amber-400" data-id="element-88"></div>
                    <div className="w-2.5 h-2.5 sm:w-3 sm:h-3 rounded-full bg-green-400" data-id="element-89"></div>
                  </div>
                  <div className="mx-auto bg-white border border-gray-200 rounded-md text-[9px] sm:text-[10px] text-gray-400 px-4 sm:px-12 py-1 truncate max-w-[60%]" data-id="element-90">
                    obradigital.app/proyecto
                  </div>
                </div>

                {/* Browser Content */}
                <div className="p-3 sm:p-5 bg-gray-50/50" data-id="element-91">
                  <div className="flex justify-between items-center mb-3 sm:mb-4" data-id="element-92">
                    <div className="text-xs sm:text-sm font-semibold text-gray-800 truncate mr-2" data-id="element-93">
                      Proyecto Centro — Piso 3
                    </div>
                    <div className="flex gap-1 sm:gap-2 flex-shrink-0" data-id="element-94">
                      <span className="px-1.5 sm:px-2 py-0.5 sm:py-1 text-[8px] sm:text-[10px] font-medium bg-white border border-gray-200 rounded-full text-gray-600" data-id="element-95">
                        Piso
                      </span>
                      <span className="px-1.5 sm:px-2 py-0.5 sm:py-1 text-[8px] sm:text-[10px] font-medium bg-white border border-gray-200 rounded-full text-gray-600" data-id="element-96">
                        Fecha
                      </span>
                      <span className="hidden sm:inline px-2 py-1 text-[10px] font-medium bg-white border border-gray-200 rounded-full text-gray-600" data-id="element-97">
                        Persona
                      </span>
                    </div>
                  </div>

                  {/* Floor Plan Area */}
                  <div className="relative w-full aspect-[4/3] bg-white border border-gray-200 rounded-lg p-2 sm:p-4 overflow-hidden" data-id="element-98">
                    {/* Simplified Floor Plan SVG */}
                    <svg width="100%" height="100%" viewBox="0 0 400 300" className="opacity-40" data-id="element-99">
                      <rect x="20" y="20" width="360" height="260" fill="none" stroke="#9CA3AF" strokeWidth="2" data-id="element-100" />
                      <line x1="140" y1="20" x2="140" y2="280" stroke="#9CA3AF" strokeWidth="2" data-id="element-101" />
                      <line x1="260" y1="20" x2="260" y2="150" stroke="#9CA3AF" strokeWidth="2" data-id="element-102" />
                      <line x1="20" y1="150" x2="140" y2="150" stroke="#9CA3AF" strokeWidth="2" data-id="element-103" />
                      <line x1="260" y1="150" x2="380" y2="150" stroke="#9CA3AF" strokeWidth="2" data-id="element-104" />
                      {/* Doors */}
                      <rect x="138" y="80" width="4" height="30" fill="white" data-id="element-105" />
                      <rect x="138" y="200" width="4" height="30" fill="white" data-id="element-106" />
                      <rect x="258" y="80" width="4" height="30" fill="white" data-id="element-107" />
                      <rect x="80" y="148" width="30" height="4" fill="white" data-id="element-108" />
                      <rect x="320" y="148" width="30" height="4" fill="white" data-id="element-109" />
                    </svg>

                    {/* Pins */}
                    <div className="absolute top-[30%] left-[20%] w-3 h-3 bg-blue-500 rounded-full border-2 border-white shadow-sm" data-id="element-110"></div>
                    <div className="absolute top-[70%] left-[40%] w-3 h-3 bg-blue-500 rounded-full border-2 border-white shadow-sm" data-id="element-111"></div>
                    <div className="absolute top-[40%] right-[25%] w-3 h-3 bg-blue-500 rounded-full border-2 border-white shadow-sm" data-id="element-112"></div>

                    {/* Active Pin */}
                    <div className="absolute top-[55%] sm:top-[60%] right-[30%] sm:right-[35%]" data-id="element-113">
                      <div className="relative" data-id="element-114">
                        <div className="absolute -inset-2 bg-blue-400 rounded-full opacity-30 animate-ping" data-id="element-115"></div>
                        <div className="relative w-3.5 h-3.5 sm:w-4 sm:h-4 bg-blue-600 rounded-full border-2 border-white shadow-md z-10" data-id="element-116"></div>
                      </div>

                      {/* Detail Popup Card */}
                      <motion.div initial={{
                      opacity: 0,
                      y: 10,
                      scale: 0.9
                    }} animate={{
                      opacity: 1,
                      y: 0,
                      scale: 1
                    }} transition={{
                      delay: 0.8,
                      duration: 0.3
                    }} className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 sm:mb-3 w-32 sm:w-40 bg-white rounded-lg shadow-xl border border-gray-100 p-1.5 sm:p-2 z-20" data-id="element-117">
                        <div className="aspect-video w-full rounded bg-gray-100 mb-1.5 sm:mb-2 overflow-hidden" data-id="element-118">
                          <img src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=300&h=200&fit=crop" alt="Detalle de obra" className="w-full h-full object-cover" data-id="element-119" />
                        </div>
                        <div className="flex items-center justify-between mb-0.5 sm:mb-1" data-id="element-120">
                          <span className="font-bold text-[10px] sm:text-xs text-gray-900" data-id="element-121">
                            Carlos M.
                          </span>
                          <span className="text-[8px] sm:text-[10px] text-gray-400" data-id="element-122">
                            14:32
                          </span>
                        </div>
                        <div className="text-[8px] sm:text-[10px] text-gray-500 leading-tight" data-id="element-123">
                          Losa piso 3 — sector norte
                          <br data-id="element-124" />
                          15 ene 2026
                        </div>
                        {/* Pointer triangle */}
                        <div className="absolute -bottom-1.5 sm:-bottom-2 left-1/2 -translate-x-1/2 w-3 h-3 sm:w-4 sm:h-4 bg-white border-b border-r border-gray-100 rotate-45" data-id="element-125"></div>
                      </motion.div>
                    </div>
                  </div>
                </div>
              </div>

              {/* WhatsApp Icon & Connection */}
              <div className="absolute top-1/2 -translate-y-1/2 -left-2 sm:left-0 z-20 flex items-center" data-id="element-126">
                <motion.div animate={{
                y: [0, -5, 0]
              }} transition={{
                repeat: Infinity,
                duration: 3,
                ease: 'easeInOut'
              }} className="w-12 h-12 sm:w-16 sm:h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg border-3 sm:border-4 border-white" data-id="element-127">
                  <MessageCircle className="w-6 h-6 sm:w-8 sm:h-8 text-white fill-current" data-id="element-128" />
                </motion.div>

                {/* Connecting Arrow */}
                <div className="hidden sm:block w-16 h-0.5 bg-blue-300 relative" data-id="element-129">
                  <div className="absolute right-0 top-1/2 -translate-y-1/2 w-2 h-2 border-t-2 border-r-2 border-blue-300 rotate-45" data-id="element-130"></div>
                  <motion.div initial={{
                  scaleX: 0
                }} animate={{
                  scaleX: 1
                }} transition={{
                  repeat: Infinity,
                  duration: 2,
                  ease: 'linear'
                }} className="absolute inset-0 bg-blue-500 origin-left" data-id="element-131"></motion.div>
                </div>
              </div>

              {/* Decorative background elements */}
              <div className="absolute -top-10 -right-10 w-40 h-40 bg-blue-50 rounded-full blur-3xl -z-10" data-id="element-132"></div>
              <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-gray-100 rounded-full blur-3xl -z-10" data-id="element-133"></div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}